"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupInfoChat = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const Chat_1 = __importDefault(require("../Chat"));
const FilteredGroupInfoChat_1 = require("./FilteredGroupInfoChat");
class GroupInfoChat extends Chat_1.default {
    constructor(groupInfo, organizationUser, config, httpAdapter, socketAdapter, userDirectory, hhnStorage, chatsChatInfo) {
        super(groupInfo, organizationUser, config, httpAdapter, socketAdapter, userDirectory, chatsChatInfo);
        this.hhnStorage = hhnStorage;
    }
    openFilteredChat() {
        const { groupType } = this.chatInfo;
        const existingFilteredChat = this.hhnStorage.filteredChatStorage.getGroupChatByType(groupType, this.getChatId());
        existingFilteredChat === null || existingFilteredChat === void 0 ? void 0 : existingFilteredChat.destory();
        const filteredChat = new FilteredGroupInfoChat_1.FilteredGroupInfoChat(this.chatInfo, this.organizationUser, this.httpAdapter, this.socketAdapter, this.userDirectory);
        filteredChat.init();
        this.hhnStorage.filteredChatStorage.addChatByType(groupType, filteredChat);
        return filteredChat;
    }
    getChatId() {
        return this.chatInfo.id;
    }
    getChatType() {
        return models_1.CHAT_TYPE.GROUP;
    }
    updateGroupListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_GROUP, this.getChatId()), (data) => {
            var _a;
            const groupInfo = data.info;
            const mappedInfo = (0, mappers_1.groupInfoMapper)(groupInfo, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
            if ((_a = this._chatInfo) === null || _a === void 0 ? void 0 : _a.rpmDevices) {
                mappedInfo.rpmDevices = (mappedInfo.rpmDevices || []).map(mappedDevice => {
                    const existingDevice = this._chatInfo.rpmDevices.find(device => device.rpmDeviceId === mappedDevice.rpmDeviceId);
                    return Object.assign(Object.assign({}, mappedDevice), { readings: existingDevice
                            ? [
                                ...(existingDevice.readings || []),
                                ...(mappedDevice.readings || []),
                            ]
                            : mappedDevice.readings });
                });
            }
            this._chatInfo = Object.assign(Object.assign(Object.assign({}, this._chatInfo), mappedInfo), { email: mappedInfo.email });
            cb(this);
        });
    }
}
exports.GroupInfoChat = GroupInfoChat;
